import { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Button } from "@/components/ui/button";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";

const ContactUs = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const whatsappNumber = "919938232920"; // without +

  const handleWhatsAppSend = () => {
    if (!name || !email || !message) {
      alert("Please fill all fields before sending.");
      return;
    }

    const whatsappMessage = `
*Contact Form Enquiry*\n\n

Name: ${name}\n
Email: ${email}\n

Message:
${message}\n
    `;

    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      whatsappMessage
    )}`;

    window.open(whatsappURL, "_blank");
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Header */}
      <section className="bg-gradient-to-r from-[#0f3e3e] to-[#145858] text-white py-20 px-6 md:px-12 lg:px-24">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">Contact Us</h1>
          <p className="text-lg opacity-90">
            Reach out to us for safety training & certification
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 px-6 md:px-12 lg:px-24">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12">
          {/* Form */}
          <div className="border rounded-xl p-8 shadow-sm">
            <h2 className="text-2xl font-semibold text-[#0f3e3e] mb-6">
              Send Us a Message
            </h2>

            <form
              className="space-y-5"
              onSubmit={(e) => e.preventDefault()}
            >
              <input
                type="text"
                placeholder="Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full border rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0f3e3e]"
              />

              <input
                type="email"
                placeholder="Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0f3e3e]"
              />

              <textarea
                rows="5"
                placeholder="Your Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="w-full border rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0f3e3e]"
              />

              <Button
                type="button"
                onClick={handleWhatsAppSend}
                className="w-full bg-[#25D366] hover:bg-[#1ebe5d] text-white h-12 text-lg"
              >
                <MessageCircle className="mr-2 h-5 w-5" />
                Send via WhatsApp
              </Button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            <h2 className="text-2xl font-semibold text-[#0f3e3e]">
              Safety Training Institute
            </h2>

            <div className="flex items-start gap-4 p-5 border rounded-lg">
              <MapPin className="w-6 h-6 text-[#0f3e3e]" />
              <p className="text-muted-foreground">
                <strong>Location:</strong> Bahanaga, Balasore, Odisha <br />
                PIN – 756042
              </p>
            </div>

            <div className="flex items-center gap-4 p-5 border rounded-lg">
              <Phone className="w-6 h-6 text-[#0f3e3e]" />
              <p className="text-muted-foreground">
                <strong>Phone:</strong>{" "}
                <a
                  href="tel:+919938232920"
                  className="text-[#0f3e3e] font-medium"
                >
                  +91 9938232920
                </a>
              </p>
            </div>

            <div className="flex items-center gap-4 p-5 border rounded-lg">
              <Mail className="w-6 h-6 text-[#0f3e3e]" />
              <p className="text-muted-foreground">
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:safetytrainingbahanaga@gmail.com"
                  className="text-[#0f3e3e] font-medium"
                >
                  safetytrainingbahanaga@gmail.com
                </a>
              </p>
            </div>

            <a
              href={`https://wa.me/${whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-6 py-4 bg-[#25D366] text-white rounded-lg text-lg font-medium hover:bg-[#1ebe5d] transition"
            >
              <MessageCircle className="w-6 h-6" />
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default ContactUs;